<template>
  <div class="wrapper">
    <div class="table-wrapper">
      <table
        class="table table-striped jambo_table bulk_action fixed-header-table"
      >
        <!--表格標題-->
        <thead class="fixed-header">
          <tr class="headings">
            <th v-for="head in HEAD" class="column-title word_center">
              {{ head }}
            </th>
          </tr>
        </thead>
        <!--表格內容-->
        <tbody class="table_tbody_box">
          <Row
            v-for="bill in vx_billList"
            :bill="bill"
            :key="bill.orderId"
            @open-modal="$emit('open-modal', bill.orderId)"
          />
        </tbody>
      </table>
    </div>
    <!--頁籤-->
    <el-row>
      <el-col :offset="10">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="onPageChange"
          :current-page="paging.currentPage"
          :page-count="paging.totalPages"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { billHead } from '@/constants/tableHead'
import Row from './BillRow'

export default {
  components: {
    Row,
  },
  data() {
    return {
      paging: {
        currentPage: null,
        npp: null,
        totalPages: null,
        totalEntries: null,
      },
    }
  },
  methods: {
    ...mapActions('hailStateV2', {
      vx_fetchBillList: 'fetchBillList',
      vx_fetchReserveList: 'fetchReserveList',
    }),
    ...mapMutations('hailStateV2', {
      vx_setBillPagingCurrentPage: 'setBillPagingCurrentPage',
      vx_setDriverInfo: 'setDriverInfo',
    }),
    onPageChange(page) {
      this.paging.currentPage = page
      this.vx_setBillPagingCurrentPage(page)
      this.vx_fetchBillList()
    },
  },
  computed: {
    ...mapState('hailStateV2', {
      vx_billList: 'billList',
      vx_billPaging: 'billPaging',
    }),
  },
  created() {
    this.HEAD = billHead

    this.unwatch = this.$store.watch(
      (state) => state.hailStateV2.billPaging,
      (newPaging) => {
        /* console.log('newPaging', newPaging) */
        this.paging.totalPages = newPaging.totalPages
        this.paging.currentPage = newPaging.currentPage
      },
      {
        deep: true,
      },
    )
  },
  mounted() {
    this.vx_fetchBillList()
    this.vx_fetchReserveList()
    this.paging.currentPage = this.vx_billPaging.currentPage
    this.paging.npp = this.vx_billPaging.npp
    this.paging.totalEntries = this.vx_billPaging.totalEntries
    this.paging.totalPages = this.vx_billPaging.totalPages
  },
  beforeDestroy() {
    this.unwatch()
  },
}
</script>

<style scoped>
.table-wrapper {
  height: 90rem;
  overflow: auto;
  scrollbar-color: gray;
  scrollbar-width: thin;
  margin-bottom: 1rem;
  position: relative;
}

.fixed-header-table {
  width: 100%;
}

.fixed-header {
  position: sticky;
  top: 0;
  z-index: 10;
}

.fixed-header th {
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
  background: rgba(73, 87, 96, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/hailState/components-v2/BillList.vue